import React from 'react';

function NotFound() {
  return <div>No items found</div>;
}

export default NotFound;
